

import {  TabsIcon } from "../Icons/ComponentIcons";
import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { GetNodeComponenentAttributeBinding, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { defaultDropList } from "../Data/WBComponentDefaults";
import CreateAttributeList from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue,  GetNodeRealId,  setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { AttributeDefinition, AttributeInputType, CreateConditionalAttribute } from "../Data/WBData";
import WebDesigner from "../WebDesigner";
import { CreateBlankLayoutNode } from "../WBCanvas";

import { ToggleNames } from "vagaro-website-rendering/src/components/Binding/BindAllToggles";
import { AlignBottom, AlignCenterHorizontal, AlignCenterVertical, AlignLeft, AlignRight, AlignTop } from "../Icons/AlignmentIcons";
import { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";

import RenderTabMobileMenu from "vagaro-website-rendering/src/components/BusinessControls/RenderTabsMobileMenu";
import { GetBusinessControlListFromNode } from "../Utilities/PageDataHandler";






export default class WBTabs extends WBComponent {


    constructor(){
        super();
        this.typename =wBComponentTypeNames.tabRow;
        this.displayName = "Tabs";
        this.dropList = defaultDropList;
        this.primaryEditAttributes = ["tab-layout","tab-list","tab-alignment-cond","tab-alignment-cond2","tab-underline-width","tab-spacing","tab-radius","tab-padding"];
        this.colorFields =["tab-color","tab-text-color","tab-highlight-color","tab-text-highlight"];
        this.editList =  [...this.colorFields,"tab-alignment",...this.primaryEditAttributes,...CreateAttributeList(true,true,true,true,false)];

        this.contentEditable = false;
        this.icon = <TabsIcon/>
  
        this.cssDefinitions = [
            new NodeCSSClassDefinition(".tab-button:hover",
                [
                    {key:"tab-highlight-color",cssProperty:"background",default:"var(--theme-color-2)"},
                    {key:"tab-text-highlight",cssProperty:"color",default:""},
                  
                    
                 ]),
                 new NodeCSSClassDefinition(".tab-button",
                    [
                        {key:"tab-color",cssProperty:"background",default:"var(--theme-color-1)"},
                        {key:"tab-text-color",cssProperty:"color",default:"var(--theme-color-6)"},
                      
                        
                     ]),
                ]
        
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
          new AttributeDefinition("tab-list","Tabs","",AttributeInputType.TabsField),
          new AttributeDefinition("tab-highlight-color","Tab Highlight","",AttributeInputType.ColorField),
          new AttributeDefinition("tab-color","Tab Background","",AttributeInputType.ColorField),
          new AttributeDefinition("tab-text-color","Tab Text","",AttributeInputType.ColorField),
          new AttributeDefinition("tab-underline-width","Tab Underline","",AttributeInputType.MeasurementField,[{label:"Auto",value:""},{label:"S",value:"0px"},{label:"M",value:"4px"},{label:"L",value:"8px"}],{min:0,max:32,step:1,unit:"px"}),
          new AttributeDefinition("tab-text-highlight","Tab highlight Text","",AttributeInputType.ColorField),
          new AttributeDefinition("tab-layout","Tab Layout","",AttributeInputType.SelectField,
            [
              {label:"Tabs at Top",value:""},
              {label:"Tabs at Left",value:"left-tabs"},
            
            //   {label:<AlignBetweenHorizontal/>,value:"fill",toolTip:"Fill Width"},
          
            
            ]),

            CreateConditionalAttribute("tab-alignment-cond","tab-alignment-horizontal",[{key:"tab-layout",value:""}]),
            CreateConditionalAttribute("tab-alignment-cond2","tab-alignment-vertical",[{key:"tab-layout",value:"left-tabs"}]),
          new AttributeDefinition("tab-alignment-horizontal","Tab Alignment","tab-alignment",AttributeInputType.ButtonField,
            [
              {label:"Auto",value:""},
              {label:<AlignLeft/>,value:"flex-start",toolTip:"Align Left"},
              {label:<AlignCenterHorizontal/>,value:"center",toolTip:"Align Center"},
              {label:<AlignRight/>,value:"flex-end",toolTip:"Align Right"},
            //   {label:<AlignBetweenHorizontal/>,value:"fill",toolTip:"Fill Width"},
          
            
            ]),
            new AttributeDefinition("tab-alignment-vertical","Tab Alignment","tab-alignment",AttributeInputType.ButtonField,
                [
                  {label:"Auto",value:""},
                  {label:<AlignTop/>,value:"flex-start",toolTip:"Align Left"},
                  {label:<AlignCenterVertical/>,value:"center",toolTip:"Align Center"},
                  {label:<AlignBottom/>,value:"flex-end",toolTip:"Align Right"},
                //   {label:<AlignBetweenHorizontal/>,value:"fill",toolTip:"Fill Width"},
              
                
                ]),

          new AttributeDefinition("tab-radius","Tab Radius","",AttributeInputType.FourwayMeasurmentField,
            [{label:"Auto",value:""},{label:"S",value:"4px"},{label:"M",value:"10px"},{label:"L",value:"24px"}],
            {min:0,max:50,step:1,unit:"px"}
          ),
          new AttributeDefinition("tab-padding","Tab Padding","",AttributeInputType.FourwayMeasurmentField,
            [{label:"Auto",value:""},{label:"S",value:"4px"},{label:"M",value:"10px"},{label:"L",value:"16px"}],
            {min:0,max:50,step:1,unit:"px"}
          ),
          new AttributeDefinition("tab-spacing","Tab Spacing","",AttributeInputType.MeasurementField,
            [{label:"Auto",value:""},{label:"S",value:"6px"},{label:"M",value:"24px"},{label:"L",value:"48px"}],
            {min:0,max:100,step:1,unit:"px"}),
        ]
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        for(let i = 0;i<3;i++){
            let container = CreateBlankLayoutNode(wBComponentTypeNames.tabContainer);
            manager.moveComponentByObj(container,thisLayout,0);
        }


        setNodeComponentAttributeValue(thisLayout,"tab-list","\n\n");
     
    }
    GetComponentGlobalCSS(node: LayoutNode, isEditor?: boolean, isLivePublish?: boolean): string {

        let str = super.GetComponentGlobalCSS(node,isEditor,isLivePublish);
        
        str += GetStyling(node,false);
        return str;
    }
    
    


    RenderLayout({component,children,screenSize,isEditor}:WBRenderProps)
     {

        let tabString = getNodeComponentAttributeValue(component,"tab-list","Tab 1");
        let tabNames = tabString.split("\n");
       
        let layout = getNodeComponentAttributeValue(component,"tab-layout","");
        let selectedTab = (isEditor?getNodeComponentAttributeValue(component,"selectedTab","0"):"0");
        const atts = GetNodeDomAttributes(ToggleNames.toggleable+" v-tabs max-100 w-full no-shrink "+ToggleNames.toggledToIndex+selectedTab,component,screenSize,isEditor);
        let underline = getNodeComponentAttributeValue(component,"tab-underline-width","2px");
        let radius = getNodeComponentAttributeValue(component,"tab-radius","");
        let padding = getNodeComponentAttributeValue(component,"tab-padding","");
        let spacing = getNodeComponentAttributeValue(component,"tab-spacing","0px");
     
        let alignment = getNodeComponentAttributeValue(component,"tab-alignment","fill");
        let style:any = {};
        if(radius!="")
            style["borderRadius"] = radius;
        if(padding!="")
            style["padding"] = padding
        if(alignment=="fill"){
            style["width"] = "100%";
        }
     
        style.margin = "0";
        if(layout!="left-tabs"||alignment=="fill")
        style.height = "100%";
        if(layout=="left-tabs")
        style.width = "100%";

        style.position = "relative";
        style.overflow = "hidden";
        style.minWidth = "fit-content";
        if(layout=="left-tabs")
            style.minHeight = "2.5em";
        let rowStyle:any = {};
        if(alignment!=""&&alignment!="fill")
            rowStyle["justifyContent"] = alignment;
        if(spacing!="")
            rowStyle["gap"] = spacing;
        if(layout=="")
        rowStyle.maxHeight = "500px";
        else
            rowStyle.height = "100%";
        rowStyle.overflow = "auto";
  ;
        rowStyle.flexShrink = 0;
        rowStyle.display = "flex";
        rowStyle.flexDirection = layout=="left-tabs"?"column":"row";
        return (
        <div {...atts}>
            {isEditor&&<style>{super.GetComponentGlobalCSS(component,true)+GetStyling(component,true)}</style>}
            <div className="tab-dropdown-portal relative" style={{zIndex:5}}></div>
            <div className="w-full h-full main-tab-wrapper  resizable-container" style={{overflow:"auto", display:"flex",flexDirection:(layout=="left-tabs"?"row":"column")}}>
            <div className=" gap-med main-tab-row" style={rowStyle} >
         
                {
                    tabNames.map((tabName, index) => {
                        let t = tabName.length>0?tabName:"Tab "+(index+1);

                        return <button 
                        role="tab"
                        style={style}
                        key={index} id={"tab-button-"+index}
                        {...{[ToggleNames.ToggleIndexAttribute]:index}}    
                        className={"invisible-button v-button inherit-font-w tab-button tab-button-"+index+" "+ToggleNames.toggleNumbered+" "+ToggleNames.toggleTrigger+" "+ToggleNames.findToggleInParent}
                        onClick={()=>{
                            setNodeComponentAttributeValue(component,"selectedTab",index.toString());

                            component.forceUpdate&&component.forceUpdate();
                            (window as any).updateTabInput&&(window as any).updateTabInput();
                        }}
                        
                        >{t}
                        {underline&&<div className="underline"  style={{display:"none"}} > <svg  style={{verticalAlign:"top"}} preserveAspectRatio="none" height={"100%"} width={"100%"} xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 100 100"> <rect width="100" height="100" /></svg></div>}
                        
                        </button>
                    })
                }
            </div>
         
            {!isEditor? <div {...GetNodeComponenentAttributeBinding(mapComponentToNewTab(component),isEditor,wBComponentTypeNames.tabMobileMenu) } /> :
            <RenderTabMobileMenu key={selectedTab} inSelection={parseInt(selectedTab)} node={component}  isEditor={true}/>}
            {children}
            </div>
        </div>
        );
   
    }

}


function mapComponentToNewTab(component:LayoutNode){

    let newComponent = CreateBlankLayoutNode(wBComponentTypeNames.tabMobileMenu);
  
    let clist = "";
    for(let i = 0;i<component.children.length;i++){
         clist += GetBusinessControlListFromNode(component.children[i]).join(",");

         if(component.children[i].children.length==0){
            clist+="empty";// flag as a component so it will always be hidden
         }
         clist+="\n";
    
    
    }


    setNodeComponentAttributeValue(newComponent,"realid",GetNodeRealId(false,component))
    setNodeComponentAttributeValue(newComponent,"component-lists",clist);
    setNodeComponentAttributeValue(newComponent,"tab-list",getNodeComponentAttributeValue(component,"tab-list",""));
    return newComponent
}


function GetStyling(node: LayoutNode,isEditor?:boolean): string {

    let str = "";
    let bg = getNodeComponentAttributeValue(node,"tab-highlight-color","var(--theme-color-2)");
    let text = getNodeComponentAttributeValue(node,"tab-text-highlight","var(--theme-color-6)");
    let underline = getNodeComponentAttributeValue(node,"tab-underline-width","2px");

    let bgHighlightCSS = bg?"background: "+bg+" !important;":"";
    let textHighlightCSS = text?"color: "+text+"  !important;":"";
    

    const realid = (isEditor) ? "#"+node.id : "#v" + node.id;
    for(let i = 0;i<node.children.length;i++){

        str += 
    `.toggled-to-${i}>div>.v-tab-container-${i}{ display: flex !important; }

    ${realid}.toggled-to-${i}>div>div>.tab-button-${i}{
  
    ${bgHighlightCSS}
    ${textHighlightCSS}

    } 
    

     `
 if(underline){
            str += 
            `${realid}.toggled-to-${i}  .tab-button-${i} .underline{
            
                width:100%;
                height:${underline};
                display:block !important;
                position:absolute;
                bottom:0;
                left:0;

            }`
        }


    }

    let mobileClass = `.tabs-mobile-menu { display: block !important; } .menu-opened .v-tab-container{pointer-events:none;} `;
    let hideMain = ".main-tab-row{ display: none !important; }  .main-tab-wrapper  {flex-direction:column !important} ";

    // str += "@media (min-width: 768px) {"+mobileClass+"}";
    
    str += "@container (max-width: 768px) {"+mobileClass+ hideMain+"}";
    str += "@media (max-width: 768px) {"+mobileClass+ hideMain+"}";
    // str += "@media (max-width: 768px) {"+hideMain+"}";

    
    //fix overflow issues with classes & book now. Include here vs css file to avoid bloating css file
    str+=`
        .v-tab-container [data-link-key="classes"], [data-link-key="book-now"]{
        margin-bottom: 5px;
        }
        `

    return str;

}